export enum TypePoint {
  hotel = 'hotel',
  transfer = 'transfer',
  destination = 'destination',
  airport = 'airport',
  ferry = 'ferry',
  internet = 'internet',
}
